import React from 'react';
import { Pagination, Filter, List, Edit, Create, SimpleForm, DatagridConfigurable, TextField, TextInput, NumberInput } from 'react-admin';
import { ColorField, ColorInput } from './ColorComponents';
import { stripedDataGridSx } from './styles/dataGridStyles';
import Empty from './components/Empty';
import FactoryIcon from '@mui/icons-material/Factory';

const PickupLocationFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

const PickupLocationPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const PickupLocationList = props => {
    return (
        <List
            title="Pickup Locations"
            filters={<PickupLocationFilter />}
            perPage={100}
            pagination={<PickupLocationPagination />}
            sort={{ field: 'Pickup_Location', order: 'ASC' }}
            bulkActionButtons={false}
            empty={<Empty icon={FactoryIcon} title="No pickup locations yet" description="Add your first pickup location to get started" />}
            {...props}
        >
            <DatagridConfigurable
                rowClick="edit"
                sx={stripedDataGridSx}
            >
                <ColorField label="Color" source="Mill_Color" showText={false} />
                <TextField label="Pickup Location" source="Pickup_Location" />
                <TextField label="Street" source="Mill_Street_Address" />
                <TextField label="City" source="Mill_City" />
                <TextField label="State" source="Mill_State" />
                <TextField label="Zip" source="Mill_Zip" />
                <TextField label="County" source="Mill_County" />
                <TextField label="Contacts" source="Mill_Contacts" />
                <TextField label="Phone" source="Mill_Phone" />
                <TextField label="Pickup Hours" source="Mill_PickUp_Hours" />
                <TextField label="Email" source="Mill_Email" />
            </DatagridConfigurable>
        </List>
    )
}

export const PickupLocationEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm>
            <TextInput disabled label="ID" source="id" />
            <TextInput label="Pickup Location" source="Pickup_Location" />
            <TextInput label="Street Address" source="Mill_Street_Address" />
            <TextInput label="City" source="Mill_City" />
            <TextInput label="State" source="Mill_State" />
            <TextInput label="Zip" source="Mill_Zip" />
            <TextInput label="County" source="Mill_County" />
            <TextInput label="Contacts" source="Mill_Contacts" />
            <TextInput label="Phone" source="Mill_Phone" />
            <TextInput label="Fax" source="Mill_Fax" />
            <TextInput label="Email" source="Mill_Email" />
            <TextInput label="Pickup Hours" source="Mill_PickUp_Hours" />
            <ColorInput source="Mill_Color" label="Color" />
        </SimpleForm>
    </Edit>
);

export const PickupLocationCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput label="Pickup Location" source="Pickup_Location" />
            <TextInput label="Street Address" source="Mill_Street_Address" />
            <TextInput label="City" source="Mill_City" />
            <TextInput label="State" source="Mill_State" />
            <NumberInput label="Zip" source="Mill_Zip" />
            <TextInput label="County" source="Mill_County" />
            <TextInput label="Contacts" source="Mill_Contacts" />
            <TextInput label="Phone" source="Mill_Phone" />
            <TextInput label="Fax" source="Mill_Fax" />
            <TextInput label="Email" source="Mill_Email" />
            <TextInput label="Pickup Hours" source="Mill_PickUp_Hours" />
            <ColorInput source="Mill_Color" label="Color" />
        </SimpleForm>
    </Create>
);
